import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { HttpBackend, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import languageReducer, { name as languageFeatureName } from './features/language.slice';
import { LANGUAGE_CONFIG, LANGUAGE_CONSTANTS } from './language.config';
import { LanguageEffects } from './effects/language.effects';

export function HttpLoaderFactory(http: HttpBackend) {
  return new TranslateHttpLoader(new HttpClient(http));
}

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(_params: MissingTranslationHandlerParams) {
    return null;
  }
}

@NgModule({ declarations: [], imports: [CommonModule,
        StoreModule.forFeature(languageFeatureName, languageReducer),
        EffectsModule.forFeature([LanguageEffects])], providers: [{ provide: LANGUAGE_CONFIG, useValue: LANGUAGE_CONSTANTS }, provideHttpClient(withInterceptorsFromDi())] })
export class LanguageModule {}
